module.exports = __webpack_public_path__ + "media/images/logo-7d3d2821421f8168f26cc93e5db568b7.png";